import React from "react";

import TableV2IconButton from "./TableV2IconButton";
import DropDown from "../../DropDown/DropDown";

export interface TableV2RowAction {
  /** Needed when two actions share a title */
  id?: string;
  title: string;
  onClick: () => void;
  icon?: string;
  visible?: boolean;
}

const RowActions = ({
  items,
  label = "Row actions",
  testId = "row-actions",
}: {
  items: TableV2RowAction[];
  label?: string;
  testId?: string;
}) => {
  const visible = items.filter((item) => item.visible !== false);
  if (visible.length === 0) return null;

  return (
    <DropDown direction="left">
      <DropDown.Toggle testId={testId}>
        <TableV2IconButton
          tooltip={false}
          icon="fa-solid fa-ellipsis"
          label={label}
          onClick={() => undefined}
        />
      </DropDown.Toggle>
      <DropDown.Menu>
        {visible.map((item, index) => (
          <DropDown.Item
            key={item.id ?? `${index}:${item.title}`}
            value={item.title}
            onClick={item.onClick}
          >
            {item.icon && (
              <i className={`fa-solid ${item.icon}`} style={{ width: 20 }} />
            )}
            {item.title}
          </DropDown.Item>
        ))}
      </DropDown.Menu>
    </DropDown>
  );
};

export default RowActions;
